import app from '../../public-api';
import {RenderEngine, RegionOfInterest} from './drawing/index';
import {
  ClientDownloader,
  ServerDownloader,
  ViewportScanner,
  ImageReader,
  createAnnotationsReader
} from './capturing/index';
import {createButton} from './toolbar-button/toolbar-button';
import {createToolUiButton} from './toolbar-button/show-ui-button';
import {ViewportHelper} from './ViewportHelper';
import {DESTINATIONS, SnapshotSettingsService, rules, Validator} from './settings/index';
import {DataBinder, MainUi} from './tool/index';
import {go} from './snapshot-event-coordinator';

app.plugins.register({
  name: 'us:snapshot',

  extends: 'uScope',

  // TODO: Make optional.
  dependencies: ['us:annotations:service-locator', 'us:user-config'],

  canStart () {
    // Need access to the URL API.
    return !!window.URL;
  },

  constructor: function (uScope, annotationsServiceLocator, userConfig) {
    const settings = new SnapshotSettingsService(userConfig, new Validator(rules));
    const dataBinder = new DataBinder(settings);
    const ui = new MainUi(document.body, dataBinder, doSnapshot);

    const settingsButton = createToolUiButton(ui);
    const button = createButton(settingsButton, doSnapshot);

    uScope.topToolbar.addButton(button);

    function doSnapshot () {
      const viewport = uScope.getThisImage();
      if (!viewport) {
        return;
      }

      const eventChannel = uScope.events.$new();
      const regionOfInterest = new RegionOfInterest(eventChannel, new RenderEngine());
      const viewportHelper = new ViewportHelper(viewport);
      const scanner = new ViewportScanner([new ImageReader(), createAnnotationsReader(annotationsServiceLocator)]);
      const downloader = settings.destination === DESTINATIONS.SERVER ? new ServerDownloader(annotationsServiceLocator) : new ClientDownloader(scanner);

      go(uScope.notifications, viewport, eventChannel, settings, ui, downloader, regionOfInterest, viewportHelper);
    }
  }
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/snapshot-loader.js